import { render, staticRenderFns } from "./resetTradePwd.vue?vue&type=template&id=1d322fcd&scoped=true&"
import script from "./resetTradePwd.vue?vue&type=script&lang=js&"
export * from "./resetTradePwd.vue?vue&type=script&lang=js&"
import style0 from "./resetTradePwd.vue?vue&type=style&index=0&id=1d322fcd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d322fcd",
  null
  
)

export default component.exports